import Vue from 'vue'

import VueScrollStop from 'vue-scroll-stop'
import Toasted from 'vue-toasted'

import * as VueGoogleMaps from 'vue2-google-maps'

import axios from 'axios'
import VueAxios from 'vue-axios'

import './firebase'
//import './registerServiceWorker'

import App from './App.vue'
import router from './router'
import store from './store'
import AppPage from './components/Layout/AppPage.vue'
import AppHeader from './components/Layout/AppHeader.vue'
import AppSection from './components/Layout/AppSection.vue'

Vue.config.productionTip = false

Vue.use(VueScrollStop)
Vue.use(VueAxios, axios)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDXluXtf7wj0858s0p21pVX8ZEuUDCuzvw',
    libraries: 'places'
  }
})

Vue.use(Toasted, {
  iconPack: 'fontawesome',
  position: 'bottom-center',
  duration: 1500
})

Vue.component('AppPage', AppPage)
Vue.component('AppHeader', AppHeader)
Vue.component('AppSection', AppSection)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
